module.exports = __webpack_public_path__ + "static/img/m4.7b0b373.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m4.png
// module id = 1fG5
// module chunks = 0